import { GrocyProductAction } from '../../../../core/entities/grocy/product-actions/product-action.entity';
import { GrocyQuantityUnitBasics } from '../../../../core/entities/grocy/quantity-units/quantity-unit-basics.entity';
import { GrocyStockEntry } from '../../../../core/entities/grocy/stock-entries/stock-entry.entity';
import { BaseForm } from '../../../../forms/forms/base.form';
import { GrocyDashboardQuickActionFormControls } from '../form-controls/dashboard-quick-action.form-controls';
import { GrocyDashboardSelectedProduct } from '../models/dashboard-selected-product.model';

export abstract class GrocyDashboardQuickActionForm<
  T extends GrocyDashboardQuickActionFormControls,
> extends BaseForm<T> {
  public abstract get amountHint(): string | undefined;
  public abstract get productAction(): GrocyProductAction;
  public abstract get quantityUnit(): GrocyQuantityUnitBasics | undefined;
  public abstract canSelectStockEntry(stockEntry: GrocyStockEntry): boolean;
  public abstract setAmountToMax(): void;
  protected abstract setChangeListeners(): void;
  protected abstract setInitialValues(): void;

  protected _selectedProduct: GrocyDashboardSelectedProduct | null = null;

  public get amount(): number {
    return this.formGroup.controls.amount.value;
  }

  override get controls(): T {
    return this.formGroup.controls as T;
  }

  public get quantityUnitName(): string {
    if (this.quantityUnit) {
      return this.amount === 1 ? this.quantityUnit.name : this.quantityUnit.namePlural;
    } else return '';
  }

  public get selectedProduct(): GrocyDashboardSelectedProduct | null {
    return this._selectedProduct;
  }

  public set selectedProduct(selectedProduct: GrocyDashboardSelectedProduct | null) {
    this._selectedProduct = selectedProduct;
    this.setInitialValues();
    this.setChangeListeners();
  }

  disable(): void {
    for (const control in this.controls) {
      this.controls[control].disable();
    }
  }

  enable(): void {
    for (const control in this.controls) {
      this.controls[control].enable();
    }
  }
}
